/**
 * @file testimonialCard.component.tsx
 * @path apps/website/src/components/sections/testimonialCard.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";
import { Star } from "lucide-react";

export const TestimonialCard = ({
  rating,
  quote,
  author,
  company,
}: {
  rating: number;
  quote: string;
  author: string;
  company?: string;
}) => {
  return (
    <div className="bg-green-500 rounded-2xl p-6 md:p-8 flex flex-col h-full max-h-fit mb-6">
      <div className="flex items-center gap-4 mb-4">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={cn(
                "w-4 h-4",
                i < rating
                  ? "fill-secondary text-secondary"
                  : "fill-muted-foreground text-muted-foreground"
              )}
            />
          ))}
        </div>
      </div>
      <blockquote className="font-sans leading-relaxed text-muted flex-grow">
        {quote}
      </blockquote>
      <div className="mt-4">
        <div className="font-bold font-sans text-sm text-primary-foreground">
          {author}
        </div>
        {company && (
          <div className="text-sm font-sans text-muted">{company}</div>
        )}
      </div>
    </div>
  );
};
